/**
 * État initial d'une fenêtre de rédaction (ComposeWindow), à partir de ce que
 * l'appelant pré-remplit : `subject`, `to`, `body`, `sinistre`, `nature`…
 *
 * L'objet est rangé sous `sujet` et le corps sous `body` : ce sont les champs que
 * ComposeWindow lit et envoie. L'objet était rangé sous `subject`, que la fenêtre
 * ne lit pas, et le corps forcé à vide : une réponse partait sans « Re: », un
 * transfert sans « Tr: » ni le message transféré. Les appelants écrivent `subject`
 * (Messagerie) ou `sujet` (LecteurConversation) : les deux sont acceptés.
 */
export const fenetreRedaction = (id, preset = {}) => ({
  id, minimized: false, maximized: false, tab: 'libre',
  sujet: preset.sujet || preset.subject || '',
  to: preset.to || [],
  sinistreId: preset.sinistreId || '',
  sinistre: preset.sinistre || '',
  nature: preset.nature || '',
  body: preset.body || '',
  templateId: '',
  title: preset.title || 'Nouveau message',
});
